import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '../../../_shared/shared.service';
import { Constants } from '../../../_consts/constants';
import { Router } from '@angular/router';
import { take } from 'rxjs';

@Component({
  template: '<div></div>',
  imports: []
})
export class RedirectorComponent implements OnDestroy {

  watcher: any

  constructor(private shared: SharedService, private router: Router) {
    if (shared.rightsAll)
      this.redirect()
    else {
      this.watcher = this.shared.rightsAllWatch.subscribe((rights) => {
        if (rights)
          this.redirect()
      })
    }
  }

  ngOnDestroy(): void {
    if (this.watcher)
      this.watcher.unsubscribe()
  }

  redirect() {
    for (let app of Constants.APPS) {
      if (this.shared.rightsAll[app.code]) {
        this.router.navigate([app.url]);
        return
      }
    }

  }

}
